import { registerLocale, getName } from 'i18n-iso-countries';
registerLocale(require('i18n-iso-countries/langs/en.json'));

const getCountryName = (id: string) => getName(id.toUpperCase(), 'en') || id;
export { getCountryName };
